import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconSearchOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M14.333 4.333c5.523 0 10 4.477 10 10a9.97 9.97 0 0 1-2.257 6.328l5.964 5.965a1 1 0 1 1-1.414 1.414l-5.965-5.965a9.96 9.96 0 0 1-6.328 2.258c-5.522 0-10-4.477-10-10s4.478-10 10-10m0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16" clipRule="evenodd" /></svg>;
export default SvgIconSearchOutlined;